import { CalendarClock } from "lucide-react";
import { fmtDate } from "@/lib/dates";

export const isInfantChild = (child) => (child?.age_group || "").toLowerCase().startsWith("infant");

// DCY 01218 should be refreshed every 3 months as the infant's needs change.
export function infantReviewDueOn(lastUpdated) {
  if (!lastUpdated) return null;
  const [y, m, d] = String(lastUpdated).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return null;
  const lastDay = new Date(y, m + 2 + 1, 0).getDate();
  return new Date(y, m + 2, Math.min(d, lastDay));
}

export const isInfantReviewDue = (child, lastUpdated) => {
  const due = isInfantChild(child) ? infantReviewDueOn(lastUpdated) : null;
  if (!due) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return due <= today;
};

export const InfantReviewChip = ({ child, lastUpdated, testid }) => {
  if (!isInfantReviewDue(child, lastUpdated)) return null;
  return (
    <span
      data-testid={testid}
      title={`DCY 01218 last updated ${fmtDate(lastUpdated)} — update it every 3 months as the infant's needs change.`}
      className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-800"
    >
      <CalendarClock className="w-3 h-3" /> Review due · infant form
    </span>
  );
};
